import React from "react";
import "../styles/A11yCheckButton.css";

export interface A11yCheckButtonProps {
  busy?: boolean;
  active?: boolean;
  onClick: () => void;
  className?: string;
}

export const A11yCheckButton: React.FC<A11yCheckButtonProps> = ({
  busy = false,
  active = false,
  onClick,
  className = ""
}) => {
  return (
    <button
      type="button"
      className={`puck-button puck-button-medium puck-button-secondary`.trim()}
      onClick={onClick}
      disabled={busy}
      aria-pressed={active}
      aria-label={
        busy
          ? "Scanning for accessibility issues"
          : active
          ? "Close A11y Check panel"
          : "Run A11y Check (WCAG 2.1 AA)"
      }
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3l0 50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6l0-50.1c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"></path>
      </svg>
      <span>{busy ? "Scanning…" : active ? "Close A11y" : "A11y Check"}</span>
    </button>
  );
};
